"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("schedules").controller("ScheduleCtrl", ScheduleCtrl);

  function ScheduleCtrl($rootScope, $scope, $controller, $timeout, moment, FormlyService, OperatorsService, SchedulesService, params) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "ScheduleCtrl";

    vm.log = debug("pages:schedule");

    vm.createFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = {
                class: "col-xs-12 col-sm-1 col-md-1",
                boxes: []
              };
              _context.t1 = FormlyService;
              _context.next = 4;
              return OperatorsService.getSelectArray();

            case 4:
              _context.t2 = _context.sent;
              _context.t3 = {
                className: "col-xs-12 col-sm-6"
              };
              _context.t4 = _context.t1.list.call(_context.t1, "userId", "Conseiller/ère", _context.t2, true, _context.t3);
              _context.t5 = FormlyService.date("fromDate", "Date de début", true, {
                className: "col-xs-12 col-sm-6"
              });
              _context.t6 = FormlyService.time("startTime", "Heure de début", true, {
                className: "col-xs-12 col-sm-6"
              });
              _context.t7 = FormlyService.time("endTime", "Heure de fin", true, {
                className: "col-xs-12 col-sm-6"
              });
              _context.t8 = FormlyService.rrule("rrule", {
                className: "col-xs-12 col-sm-12"
              });
              _context.t9 = FormlyService.text("name", "Description", false, {
                className: "col-xs-12 col-sm-12"
              });
              _context.t10 = FormlyService.textArea("note", "Commentaires", "...", false, {
                className: "col-xs-12 col-sm-12"
              });
              _context.t11 = [_context.t4, _context.t5, _context.t6, _context.t7, _context.t8, _context.t9, _context.t10];
              _context.t12 = {
                mainTitle: "Informations",
                fields: _context.t11
              };
              _context.t13 = [_context.t12];
              _context.t14 = {
                class: "col-xs-12 col-sm-5 col-md-5",
                boxes: _context.t13
              };
              _context.t15 = {
                class: "col-xs-12 col-sm-5 col-md-5",
                boxes: [{
                  mainTitle: "Clients autorisés (liste vide = tous les clients) :",
                  fields: [{
                    key: "enabledCustomersId",
                    id: "enabledCustomersId",
                    type: "select-customers",
                    className: "col-xs-12 col-sm-12",
                    templateOptions: {
                      label: ""
                    }
                  }]
                }]
              };
              _context.t16 = [_context.t0, _context.t14, _context.t15];
              _context.t17 = {
                columns: _context.t16
              };
              vm.rows = [_context.t17];


              $timeout(function () {}, 0);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.check = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var save, start, offsetUtc, startTime, end, endTime;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = true;
              start = moment(vm.model.fromDate);


              vm.log("offset date:", start.utcOffset());

              offsetUtc = start.utcOffset();
              startTime = vm.model.startTime.split(":");


              start = start.set({
                hour: startTime[0],
                minute: startTime[1],
                second: 0
              });

              vm.model.fromDate = start.toDate();

              if (vm.model.rrule && vm.model.rrule.until) {
                end = moment(vm.model.rrule.until);
              } else {
                if (!vm.model.rrule) {
                  end = moment(vm.model.fromDate);
                }
              }

              if (end) {
                endTime = vm.model.endTime.split(":");


                end = end.set({
                  hour: endTime[0],
                  minute: endTime[1],
                  second: 0
                });

                vm.model.endDate = end.toDate();
              } else {
                vm.model.endDate = null;
              }

              if (save) {
                console.log("vm.model", vm.model);
                vm.save();
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    vm.ready = function () {
      if (!vm.model.startTime) {
        vm.model.startTime = "09:00";
      }

      if (!vm.model.endTime) {
        vm.model.endTime = "17:00";
      }

      $timeout(function () {
        vm.createFields();
      }, 0);
    };

    $controller("CreateBaseController", {
      vm: vm,
      $scope: $scope,
      service: SchedulesService,
      listPage: "schedules",
      nameModel: "une plage de disponibilité",
      params: params
    });
  }
})();